module.exports = __webpack_public_path__ + "static/level_3.69d52599.png";